import Box from "@mui/material/Box";
import { useState } from "react";

import {
  DashboardMenuItem,
  MenuItemLink,
  MenuProps,
  useSidebarState,
} from "react-admin";

import SubMenu from "./layout/SubMenu";
import users from "./pages/User";
import userWallets from "./pages/user/UserWallet";
// import coinProtocols from "./pages/coin/CoinProtocol";
import exchangeOrders from "./pages/exchange/ExchangeOrder";
import { icon as ExchangeMarginIcon } from "./pages/exchange/ExchangeMargin";
import fundCurrentUsers from "./pages/fund/FundCurrentUser";
import nftOrders from "./pages/nft/NftOrder";
import MySecurity from "./pages/user/MySecurity";
import OwOrder from "./pages/ow/OwOrder";
import UserSetting from "./pages/ow/UserSetting";
import OwUserSd from "./pages/ow/OwUserSd";
import AgentSetting from "./pages/ow/AgentSetting";

type MenuName =
  | "menuOrder"
  | "menuExchange"
  | "menuCoin"
  | "menuCatalog"
  | "menuUsers"
  | "menuAdmins"
  | "menuContent"
  | "menuOw";

const Menu = ({ dense = false }: MenuProps) => {
  const [state, setState] = useState({
    menuCatalog: true,
    menuUsers: true,
    menuExchange: true,
    menuAdmins: true,
    menuContent: true,
    menuOrder: true,
    menuCoin: true,
    menuOw: true,
  });
  const [open] = useSidebarState();

  const handleToggle = (menu: MenuName) => {
    setState((state) => ({ ...state, [menu]: !state[menu] }));
  };

  return (
    <Box
      sx={{
        width: open ? 200 : 50,
        marginTop: 1,
        marginBottom: 1,
        transition: (theme) =>
          theme.transitions.create("width", {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
          }),
      }}
    >
      <DashboardMenuItem />
      <SubMenu
        handleToggle={() => handleToggle("menuUsers")}
        isOpen={state.menuUsers}
        name="会员管理"
        icon={<users.icon />}
        dense={dense}
      >
        <MenuItemLink
          to="/users"
          state={{ _scrollToTop: true }}
          primaryText={"会员管理"}
          leftIcon={<users.icon />}
          dense={dense}
        />
        <MenuItemLink
          to="/userWallets"
          state={{ _scrollToTop: true }}
          primaryText={"钱包管理"}
          leftIcon={<userWallets.icon />}
          dense={dense}
        />
        <MenuItemLink
          to="/authKey"
          state={{ _scrollToTop: true }}
          primaryText={"2FA 绑定"}
          leftIcon={<MySecurity.icon />}
          dense={dense}
        />
      </SubMenu>
      <SubMenu
        handleToggle={() => handleToggle("menuOrder")}
        isOpen={state.menuOrder}
        name="订单管理"
        icon={<exchangeOrders.icon />}
        dense={dense}
      >
        <MenuItemLink
          to="/exchangeMarginsLeverage"
          state={{ _scrollToTop: true }}
          primaryText={"杠杆仓位"}
          leftIcon={<ExchangeMarginIcon sx={{ color: "#3ac181" }} />}
          dense={dense}
        />
        <MenuItemLink
          to="/exchangeMarginsContract"
          state={{ _scrollToTop: true }}
          primaryText={"合约仓位"}
          leftIcon={<ExchangeMarginIcon sx={{ color: "#f74a4c" }} />}
          dense={dense}
        />
        <MenuItemLink
          to="/exchangeOrders"
          state={{ _scrollToTop: true }}
          primaryText={"交易订单"}
          leftIcon={<exchangeOrders.icon />}
          dense={dense}
        />
        <MenuItemLink
          to="/nftOrders"
          state={{ _scrollToTop: true }}
          primaryText={"NFT订单"}
          leftIcon={<nftOrders.icon />}
          dense={dense}
        />
        <MenuItemLink
          to="/fundTermUsers"
          state={{ _scrollToTop: true }}
          primaryText={"基金持仓"}
          leftIcon={<fundCurrentUsers.icon />}
          dense={dense}
        />
        <MenuItemLink
          to="/fundCurrentUsers"
          state={{ _scrollToTop: true }}
          primaryText={"活期持仓"}
          leftIcon={<fundCurrentUsers.icon />}
          dense={dense}
        />
      </SubMenu>
      <SubMenu
        handleToggle={() => handleToggle("menuOw")}
        isOpen={state.menuOw}
        name="微交易"
        icon={<OwOrder.icon />}
        dense={dense}
      >
        <MenuItemLink
          to="/owOrder"
          state={{ _scrollToTop: true }}
          primaryText={"微交易订单"}
          leftIcon={<OwOrder.icon />}
          dense={dense}
        />
        <MenuItemLink
          to="/userSetting"
          state={{ _scrollToTop: true }}
          primaryText={"用户设置"}
          leftIcon={<UserSetting.icon />}
          dense={dense}
        />
        <MenuItemLink
          to="/owUserSd"
          state={{ _scrollToTop: true }}
          primaryText={"用户盈亏设置"}
          leftIcon={<OwUserSd.icon />}
          dense={dense}
        />
        <MenuItemLink
          to="/owAgentSd"
          state={{ _scrollToTop: true }}
          primaryText={"所有子用户盈亏"}
          leftIcon={<OwUserSd.icon />}
          dense={dense}
        />
        <MenuItemLink
          to="/agentSetting"
          state={{ _scrollToTop: true }}
          primaryText={"总体盈亏比例"}
          leftIcon={<AgentSetting.icon />}
          dense={dense}
        />
      </SubMenu>
    </Box>
  );
};

export default Menu;
